import { FC, useEffect, useState } from 'react';
import { Grid as KendoGrid, GridColumn } from '@progress/kendo-react-grid';
import useCustomer from 'src/hooks/useCustomer';
import { State as ODataState } from '@progress/kendo-data-query';
import NumberCell from 'src/components/grid/NumberCell';
import ItemApi from 'src/api/ItemApi';
import { OnOrderItem } from 'src/types/onOrderItem';
import UomCell from 'src/components/grid/UomCell';

declare interface IProps {
  itemNumber: string;
  itemName: string;
  visible: boolean;
}

const ItemDetailOnOrder: FC<React.PropsWithChildren<IProps>> = ({ itemNumber, itemName, visible }) => {
  const { customer } = useCustomer();
  const [onOrderItems, setOnOrderItems] = useState<OnOrderItem[]>();
  const [gridDataState, setGridDataState] = useState<ODataState>({});

  useEffect(() => {
    if (itemNumber) {
      ItemApi.getOnOrderItems(itemNumber, itemName, customer.number).then((data) => {
        const processedData = data.map((d) => ({
          ...d,
          orderDate: new Date(d.orderDate),
          promisedDate: new Date(d.promisedDate),
          uniqueKey: `${d.orderNumber}-${d.lineNumber}-${d.warehouse}`,
        }));
        setOnOrderItems(processedData);
      });
    }
  }, [gridDataState, itemNumber]);

  const handleGridDataStateChange = (e: any) => {
    setGridDataState(e.dataState);
  };

  const qtyCell = (cellProps) => <UomCell {...cellProps} uomField="unitOfMeasure" />;

  return (
    <div role="tabpanel" hidden={!visible} id="on-order" aria-labelledby="on-order-tab">
      <KendoGrid data={onOrderItems} scrollable="scrollable" dataItemKey="uniqueKey" onDataStateChange={handleGridDataStateChange} {...gridDataState}>
        <GridColumn field="fullOrderNumber" title="Order #" width={100} />
        <GridColumn field="customerPO" title="Cust PO #" width={280} />
        <GridColumn field="orderDate" title="Order Date" format="{0:MM/dd/yyyy}" width={100} />
        <GridColumn field="promisedDate" title="Promised Date" format="{0:MM/dd/yyyy}" width={100} />
        <GridColumn field="quantity" format="0" cells={{ data: qtyCell }} title="Qty Ordered" width={100} />
        <GridColumn field="quantityAvailable" format="0" cells={{ data: NumberCell }} title="Qty Available" width={100} />
        <GridColumn field="price" format="c" cells={{ data: NumberCell }} title="Price" width={100} />
        <GridColumn field="" title="" editable={false} />
      </KendoGrid>
    </div>
  );
};

export default ItemDetailOnOrder;
